<template>
  <div class="col-12 d-flex flex-row flex-wrap">
    <button
      v-for="(badge, index) in badges"
      :key="badge.name + index"
      type="button"
      class="btn badge badge-pills rounded-pill me-1 d-flex flex-row mb-1"
      :class="[
        `bg-${badge.active ? badge.color : 'gray-300'} `,
        `text-${badge.active ? activeColor(badge) : 'gray-400'} `,
        badge.color === 'white' && badge.active ? 'border-blue-500' : ''
      ]"
      @click="emitChange(index)"
    >
      <span class="my-auto"> {{ badge.name }} </span>
      <v-icon
        v-show="badge.active"
        :icon="`times-${activeColor(badge)}`"
        width="8"
        height="8"
        class="ms-1 my-auto"
      />
    </button>
  </div>
</template>
<script>
export default {
  props: {
    badges: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  emits: ['update-active'],
  methods: {
    emitChange(index) {
      this.$emit('update-active', index);
    },
    activeColor({ isWhite }) {
      return isWhite ? 'white' : 'blue-700';
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 576px) {
  .badge-pills.rounded-pill {
    height: 34px;
    min-height: 34px;
  }
}
</style>
